module.exports = __webpack_public_path__ + "6418e6ffb7f94ba02b88362cb81b4681.png";